import React from "react";
import PropTypes from "prop-types";
import { Link as LinkDS } from "veloe-ds";

import {
	ContainerList,
	CardLink,
	CheckboxContainer,
	ContainerCTA
} from "./styles";
import CardTabela from "../CardTabela";
import BotaoCTA from "../BotaoCTA";
import Checkbox from "../Checkbox";

export default function ListaCardsTabela({
	listaDeCards,
	botao,
	botao2,
	regulamento,
	link
}) {
	let n_buttons = 0;
	for (let i = 0; i < listaDeCards.length; i++) {
		if (listaDeCards[i].botaoExtra) {
			n_buttons = 2;
			break;
		} else if (listaDeCards[i].botao && n_buttons < 2) {
			n_buttons = 1;
		}
	}
	return (
		<>
			<ContainerList maxOffer={listaDeCards.length > 2}>
				{listaDeCards.map((item, index) => (
					<CardTabela card={item} key={index} n_buttons={n_buttons} />
				))}
			</ContainerList>
			{regulamento && (
				<CheckboxContainer blur={regulamento.blur}>
					<Checkbox onChange={regulamento.onChange} />
					<span>
						Estou ciente que, ao prosseguir, aceito os{" "}
						<span className="underline" onClick={regulamento.show}>
							termos e condições
						</span>{" "}
						da campanha
					</span>
				</CheckboxContainer>
			)}
			<ContainerCTA n_buttons={2}>
				{botao && (
					<div className="botoesCupons">
						<BotaoCTA botao={botao} />
						<BotaoCTA botao={botao2} />
					</div>
				)}
			</ContainerCTA>

			{link && (
				<CardLink blur={link.blur}>
					<a href={link.rota.endereco} onClick={link.onClick}>
						<LinkDS>{link.label}</LinkDS>
					</a>
				</CardLink>
			)}
		</>
	);
}

ListaCardsTabela.propTypes = {
	listaDeCards: PropTypes.array,
	botao: PropTypes.shape({
		blur: PropTypes.string,
		cor: PropTypes.string,
		corLabel: PropTypes.string,
		disabled: PropTypes.bool,
		estilo: PropTypes.string,
		external: PropTypes.string,
		label: PropTypes.string,
		rota: PropTypes.shape({
			endereco: PropTypes.string,
			tagLabel: PropTypes.string,
			__typename: PropTypes.string
		}),
		__typename: PropTypes.string
	}),
	regulamento: PropTypes.shape({
		blur: PropTypes.bool,
		onChange: PropTypes.func,
		show: PropTypes.func
	}),
	link: PropTypes.shape({
		nome: PropTypes.string,
		label: PropTypes.string,
		rota: PropTypes.shape({
			endereco: PropTypes.string,
			tagLabel: PropTypes.string,
			__typename: PropTypes.string
		}),
		__typename: PropTypes.string
	})
};
